export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const REQUEST = 'REQUEST';
export const UNSET = 'UNSET';
